export default __webpack_public_path__ + "67abc9f67e6d94a09b52e9a6a3c60f2e.svg";